export default __webpack_public_path__ + "static/media/monk-2x.a3242d25.png";